import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "settings col-10 col-lg-8" }
const _hoisted_2 = { class: "form-group card p-4 mt-3" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "newsletter" }
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = { class: "two-cols-section" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "status" }
const _hoisted_10 = {
  key: 0,
  class: "progress"
}
const _hoisted_11 = { class: "help-text text-left mt-2 mb-0" }
const _hoisted_12 = { class: "two-cols-section" }
const _hoisted_13 = { class: "actions" }
const _hoisted_14 = {
  key: 0,
  class: "help-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_delete_modal = _resolveComponent("account-delete-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "title" }, "Settings", -1)),
    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "description" }, "Manage your account and preferences", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "section-title mt-0" }, "Profile", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { for: "profile-displayed-name" }, "Displayed name", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayedName) = $event)),
          id: "profile-displayed-name"
        }, null, 512), [
          [_vModelText, _ctx.displayedName]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            id: "email-consent-newsletter",
            class: "form-check-input",
            type: "checkbox",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newsletterConsent) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.newsletterConsent]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "form-check-label",
            for: "email-consent-newsletter"
          }, " Subscribe to monthly newsletter emails ", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "help-text mb-0" }, "Only GanttProject Cloud news. No spam.", -1))
        ]),
        _createElementVNode("button", {
          id: "btn-update-user-info",
          class: "btn btn-attention",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)))
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "spinner-wrapper" }, [
            _createElementVNode("i", { class: "fas fa-spinner" })
          ], -1),
          _createTextVNode(" Update ", -1)
        ]))])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "section-title" }, "Data Control", -1)),
      _createElementVNode("form", _hoisted_6, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, [
          _createElementVNode("label", { class: "mb-0" }, "Data Export"),
          _createElementVNode("p", { class: "help-text mb-0" }, " You can export data from the teams owned by you as ZIP file. ")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            class: _normalizeClass(["btn btn-attention", { disabled: _ctx.downloadStatus === 'wip' }]),
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)), ["prevent"])),
            role: "button"
          }, _toDisplayString(_ctx.downloadStatus === 'wip' ? 'Exporting...' : 'Start export'), 3),
          (_ctx.downloadStatus === 'ready')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-attention mt-2",
                id: "archive-link",
                href: _ctx.archiveLink
              }, "Download ZIP", 8, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.downloadStatus === 'wip')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("div", {
                  class: "progress-bar progress-bar-striped progress-bar-animated",
                  role: "progressbar",
                  "aria-valuenow": "75",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100",
                  style: {"width":"100%"}
                }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("p", _hoisted_11, " You don't have to wait. If export process takes considerable time, we will send you a link by email. ", 512), [
            [_vShow, _ctx.downloadStatus === 'wip']
          ])
        ])
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "section-title" }, "Account", -1)),
      _createElementVNode("div", _hoisted_12, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label" }, [
          _createElementVNode("label", { class: "mb-0" }, "Delete Account")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.accountDeleted)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Your account was deleted. "))
            : _createCommentVNode("", true),
          (!_ctx.accountDeleted)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-attention",
                id: "btn-delete-account",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDeleteAccount && _ctx.onDeleteAccount(...args))),
                type: "button"
              }, " Delete Account "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_account_delete_modal, { ref: "deleteAccountModal" }, null, 512)
  ]))
}